
import { Button } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import Contractor from "./additionalFields/Contractor.jsx";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import WithdrawalPayment from "./additionalFields/WithdrawalPayment.jsx";
import Status from "./additionalFields/Status.jsx";
import Information from "./additionalFields/Information.jsx";
import { withdrawalRequestList } from "../../services/usersServices.js";
import UploadReceipt from "./additionalFields/UploadReceipt.jsx";
import ReceiptTransaction from "./additionalFields/ReceiptTransaction.jsx";

const options = [
  {
    text: "همه درخواست ها",
    value: "",
  },
  {
    text: "پرداخت شده",
    value: "p",
  },
  {
    text: "پرداخت نشده",
    value: "n",
  }
];

const WithdrawalRequestPage = () => {
  const [forceRequest, setForceRequest] = useState(0);

  const navigate = useNavigate();

  const withdrawalRequestCols = [
    {
        field: null,
        text: "مبلغ (تومان)",
        element: (rowData) => <WithdrawalPayment rowData={rowData} />,
    },
    {
        field: null,
        text: "وضعیت",
        element: (rowData) => <Status rowData={rowData} />,
    },
    {
        field: null,
        text: "پیمانکار",
        element: (rowData) => <Contractor rowData={rowData} />,
    },
    {
        field: null,
        text: "اطلاعات بانکی",
        element: (rowData) =>  <Information rowData={rowData} />
    },
    {
        field: null,
        text: "تاریخ",
        element: (rowData) => <span>{convertDateToJalaali(rowData.transaction_date)}</span>,
    },
    {
        field: null,
        text: "آپلود رسید",
        element: (rowData) =>  <UploadReceipt rowData={rowData} />
    },
    {
        field: null,
        text: "دانلود رسید",
        element: (rowData) =>  <ReceiptTransaction rowData={rowData} />
    },
  ];

  return (
    <DataTablePagination
      tableCols={withdrawalRequestCols}
      title={"تسویه پیمانکاران"}
      APIFunction={withdrawalRequestList}
      dataField={"transactions"}
      hasOutlet={true}
      hasCatergory={true}
      categoryOptions={options}
      forceRequest={forceRequest}
      setForceRequest={setForceRequest}
    ></DataTablePagination>
  );
};

export default WithdrawalRequestPage;
